import { useQuery } from '@tanstack/react-query';

import type { PriceMessage } from '../../../../types/PricesMessage';
import { queries } from '../../../common/api/queryKeys/queries';
import { OrderState, type OrderModel } from '../../model/OrderModel';

interface DefaultContractReferenceState {
    defaultContractReference?: PriceMessage;
    isPending: boolean;
}

export const useDefaultContractReference = (order: OrderModel): DefaultContractReferenceState => {
    const vesselDefaultContractId = order.vessel?.defaultContractId;
    const vesselDefaultSupplierId = order.vessel?.defaultSupplierId;
    const defaultContractAlreadyRequested = order.receiverContractIds?.length
        ? vesselDefaultContractId !== undefined && order.receiverContractIds.includes(vesselDefaultContractId)
        : vesselDefaultSupplierId !== undefined && order.receiverSupplierIds.includes(vesselDefaultSupplierId);
    const defaultContractReferenceItems = order.items.filter((item) => !item.deleted);
    const shouldFetchDefaultContractReference =
        Boolean(vesselDefaultContractId) &&
        Boolean(order.portId) &&
        !defaultContractAlreadyRequested &&
        order.state !== OrderState.CANCELED &&
        defaultContractReferenceItems.length > 0;
    const defaultContractReferenceQuery = useQuery({
        ...queries.priceCompare.items({
            customerIds: [order.customerId],
            portIds: [order.portId],
            items: defaultContractReferenceItems,
            vesselId: order.vesselId,
            contractIds: vesselDefaultContractId ? [vesselDefaultContractId] : [],
        }),
        enabled: shouldFetchDefaultContractReference,
        select: (data) => data.prices.find((price) => price.contractId === vesselDefaultContractId),
    });
    const defaultContractReference = defaultContractReferenceQuery.data;

    return {
        defaultContractReference: shouldFetchDefaultContractReference ? defaultContractReference : undefined,
        isPending: shouldFetchDefaultContractReference && defaultContractReferenceQuery.isPending,
    };
};
